import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { emailMap } from './signUpFormConf';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';
import Mailchimp from '@/components/SignUpForm/Mailchimp';
import MailchimpView from '@/components/SignUpForm/Mailchimp/BaseFormView';
import Klaviyo from '@/components/SignUpForm/Klaviyo';
import KlaviyoView from '@/components/SignUpForm/Klaviyo/BaseFormView';
import Popup from '@/components/SignUpForm/Popup';

export default function A() {
    const { useEffect, useState, useLang, useRouter, useRef, gtm } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const [enter, setEnter] = useState(false);
    const videoRef = useRef();
    const emailConf = emailMap[locale] || emailMap.us;
    const [popupVisible, setPopupVisible] = useState(false);

    let videoMap: any = {
        us: ['/video/river2/details/kv_web_us.webm', '/video/river2/details/kv_web_us.mp4'],
        ca: ['/video/river2/details/kv_web_us.webm', '/video/river2/details/kv_web_us.mp4'],
        au: ['/video/river2/details/kv_web_au.webm', '/video/river2/details/kv_web_au.mp4'],
        cn: ['/video/river2/details/kv_web_cn.webm', '/video/river2/details/kv_web_cn.mp4'],
        eu: ['/video/river2/details/kv_web_eu.webm', '/video/river2/details/kv_web_eu.mp4'],
        de: ['/video/river2/details/kv_web_eu.webm', '/video/river2/details/kv_web_eu.mp4'],
        fr: ['/video/river2/details/kv_web_eu.webm', '/video/river2/details/kv_web_eu.mp4'],
        it: ['/video/river2/details/kv_web_eu.webm', '/video/river2/details/kv_web_eu.mp4'],
        es: ['/video/river2/details/kv_web_eu.webm', '/video/river2/details/kv_web_eu.mp4'],
        cis: ['/video/river2/details/kv_web_eu.webm', '/video/river2/details/kv_web_eu.mp4'],
        uk: ['/video/river2/details/kv_web_uk.webm', '/video/river2/details/kv_web_uk.mp4'],
        sa: ['/video/river2/details/kv_web_uk.webm', '/video/river2/details/kv_web_uk.mp4'],
        za: ['/video/river2/details/kv_web_za.webm', '/video/river2/details/kv_web_za.webm'],
        kr: ['/video/river2/details/kv_web_eu.webm', '/video/river2/details/kv_web_eu.mp4'],
    };

    if (typeof window !== 'undefined') {
        const agent = navigator.userAgent.toLowerCase();
        const isWin = agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0 || agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0;
        const isFF = agent.indexOf('firefox') >= 0;
        // window系统的火狐浏览器：无法加载播放webm格式视频问题
        if (isWin && isFF) {
            videoMap = {
                us: ['/video/river2/details/kv_web_us.mp4', '/video/river2/details/kv_web_us.webm'],
                ca: ['/video/river2/details/kv_web_us.mp4', '/video/river2/details/kv_web_us.webm'],
                au: ['/video/river2/details/kv_web_au.mp4', '/video/river2/details/kv_web_au.webm'],
                cn: ['/video/river2/details/kv_web_cn.mp4', '/video/river2/details/kv_web_cn.webm'],
                eu: ['/video/river2/details/kv_web_eu.mp4', '/video/river2/details/kv_web_eu.webm'],
                de: ['/video/river2/details/kv_web_eu.mp4', '/video/river2/details/kv_web_eu.webm'],
                fr: ['/video/river2/details/kv_web_eu.mp4', '/video/river2/details/kv_web_eu.webm'],
                it: ['/video/river2/details/kv_web_eu.mp4', '/video/river2/details/kv_web_eu.webm'],
                es: ['/video/river2/details/kv_web_eu.mp4', '/video/river2/details/kv_web_eu.webm'],
                ru: ['/video/river2/details/kv_web_eu.mp4', '/video/river2/details/kv_web_eu.webm'],
                cis: ['/video/river2/details/kv_web_eu.mp4', '/video/river2/details/kv_web_eu.webm'],
                uk: ['/video/river2/details/kv_web_uk.mp4', '/video/river2/details/kv_web_uk.webm'],
                sa: ['/video/river2/details/kv_web_uk.mp4', '/video/river2/details/kv_web_uk.webm'],
                za: ['/video/river2/details/kv_web_za.mp4', '/video/river2/details/kv_web_za.webm'],
                kr: ['/video/river2/details/kv_web_eu.mp4', '/video/river2/details/kv_web_eu.webm'],
            };
        }
    }

    useEffect(() => {
        if (!enter) {
            setTimeout(() => {
                setEnter(true);
            }, 500);
        }
    }, [videoRef]);

    return (
        <div className={`river2_details_A ${css.A_banner}`}>
            <div className="wrapper">
                <div className={`imgBox`}>
                    {locale === 'ph' ? (
                        <EcoImg ref={videoRef} pc="https://websiteoss.ecoflow.com/upload/image/1751270921812/kv.jpg" className="fullImgs" loop={false} />
                    ) : (
                        <EFVideo ref={videoRef} sources={videoMap[locale] || videoMap.us} width="100%" height="100%" className="fullImgs" loop={false} />
                    )}
                </div>
                <div className={`textBox ${enter ? 'enter' : ''}`}>
                    {[''].includes(locale) && <p className="date">{t('river2.details.sec1_date')}</p>}
                    <p className="title">{t('river2.details.sec1_title')}</p>
                    <p className="desc">{t('river2.details.sec1_desc')}</p>
                </div>
                {[''].includes(locale) && (
                    <div className={`formArea ${enter ? 'enter' : ''}`}>
                        {emailConf?.type === 'klaviyo' && (
                            <Klaviyo
                                extra_properties={{
                                    custom_source: emailConf.source,
                                    $source: emailConf.source,
                                    $method_type: 'Klaviyo Form',
                                    $consent_version: 'Embed default text',
                                    $consent_form_id: emailConf.consent_form_id,
                                }}
                                successCallback={() => {
                                    setPopupVisible(true);
                                    try {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: t('river2.sec1_btn_text'),
                                            status: 'success',
                                        });
                                        window?.fbq && window?.fbq('track', 'Lead');
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }}
                                errorCallback={() => {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'activity_submit',
                                        button_name: t('river2.sec1_btn_text'),
                                        status: 'fail',
                                    });
                                }}
                            >
                                <KlaviyoView
                                    list_id={emailConf.list_id}
                                    submitText={t('river2.sec1_btn_text')}
                                    placeholder={t('river2.sec1_input_placeholder')}
                                />
                            </Klaviyo>
                        )}
                        {emailConf.type === 'mailchimp' && (
                            <>
                                {locale === 'au' && <div className="more">{t('river2.sec1_more')}</div>}
                                <Mailchimp
                                    successCallback={() => {
                                        setPopupVisible(true);
                                        try {
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'activity_submit',
                                                button_name: t('river2.sec1_btn_text'),
                                                status: 'success',
                                            });
                                            window?.fbq('track', 'Lead');
                                        } catch (e) {
                                            console.error(e);
                                        }
                                    }}
                                    errorCallback={() => {
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                            button_name: t('river2.sec1_btn_text'),
                                            status: 'fail',
                                        });
                                    }}
                                >
                                    <MailchimpView
                                        action={emailConf.action}
                                        extraFields={emailConf.extraFields}
                                        submitText={t('river2.sec1_btn_text')}
                                        placeholder={t('river2.sec1_input_placeholder')}
                                    />
                                </Mailchimp>
                            </>
                        )}
                    </div>
                )}
            </div>
            <Popup
                visible={popupVisible}
                title={t('river2.popup_title')}
                richContent={{ langKey: 'productriver2', key: 'river2.popup_content' }}
                buttonText={t('river2.popup_btn')}
                onCancel={() => setPopupVisible(false)}
                btnLink={emailConf.popupBtnLink}
            />
            {/* 预热站点不展示购买按钮 */}
            <style jsx global>
                {`
                    .detail-nav {
                        .right {
                            .buyBtn {
                                display: ${[''].includes(locale) ? 'none' : 'block'};
                            }
                            .btn-link {
                                display: ${[''].includes(locale) ? 'none' : 'block'};
                            }
                        }
                    }
                `}
            </style>
        </div>
    );
}
